import scienceIcon1 from "@/assets/images/education/science-icon1.svg"
import scienceIcon2 from "@/assets/images/education/science-icon2.svg"
import scienceIcon3 from "@/assets/images/education/science-icon3.svg"

export const SCIENCE_DATA = {
  introductionText: {
    title: "科研合作",
    describe:
      "PingCAP 作为开源数据库领军企业，高度重视数据库领域的前沿研究。PingCAP 希望与研究机构和高校一起携手探索数据库技术的未来。",
  },
  educationValue: [
    {
      icon: scienceIcon1,
      title: "探索前沿",
      describe: "携手科研机构和高校，<br />探索未来技术发展",
    },
    {
      icon: scienceIcon2,
      title: "赋能高校",
      describe: "用产业需求、工程实现案例、<br />解决方案赋能科研伙伴",
    },
    {
      icon: scienceIcon3,
      title: "引领产业",
      describe: "根据科研探索，指导和引领<br />产业数字化转型",
    },
  ],
  cooperationModelText: {
    title: "合作模式",
    model: [
      {
        title: "PingCAP 科研计划",
        describe:
          "PingCAP 每年定期携手权威科研机构面向全球发布未来科研需求，欢迎志同道合的科研机构与高校申请项目。通过项目的提交、审批触达双方共同关注的议题。通过资源交换，共同探讨、共同研究产出理想的科研结果。",
      },
      {
        title: "开放拥抱科研",
        describe:
          "PingCAP 对全球科研机构、高校以及个人保持着开放的态度，接受主动的科研合作咨询。",
      },
    ],
  },
  cooperationFlow: {
    title: "科研合作流程",
    flow: [
      { describe: "PingCAP 发布科研计划" },
      { describe: "科研机构、高校和个人根据自己的能力和意愿申请项目" },
      { describe: "PingCAP 评审申请资料" },
      { describe: "签署合作协议，开启科研" },
    ],
  },
  contactUs: {
    title: "加入 PingCAP 科研合作计划",
    btnList: [
      {
        name: "联系我们",
        link: "/contact",
      },
    ],
  },
}
